import React, { useState, useEffect } from "react";
import MixLogo from "../../assets/images/logo.svg";
import ReactivateModel from "../../components/Reactivate-ABHA/Reactivate-model";
import { encryptString /*, createSession*/ } from "../../services/apiUtils";
import axios from "axios";
import Loader from "../../components/common/Loader";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ReactivateABHA = () => {
  const [showModal, setShowModal] = useState(false);
  const [formateAbha, setFormateAbha] = useState("");
  const [abhano, setAbhano] = useState("");
  const [OtpText, setOtpText] = useState("");
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // const [accessToken, setAccessToken] = useState("");
  const [txnId, setTxnId] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [resendCount, setResendCount] = useState(1);
  const [isReactivated, setIsReactivated] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaSessionId, setCaptchaSessionId] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [showAbha, setShowAbha] = useState(false);
  const [abhaError, setAbhaError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [otpError, setOtpError] = useState("");

  const navigate = useNavigate();
  const back = () => {
    setResendCount(1);
    navigate("/abha-home");
  };

  // Fetch captcha from backend
  const generateCaptcha = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/abha/captcha/generate`);
      if (response.data.success) {
        setCaptchaSessionId(response.data.data.sessionId);
        setCaptchaImage(response.data.data.captchaImage);
        setCaptchaInput("");
      } else {
        toast.error("Failed to generate captcha. Please try again.");
      }
    } catch (error) {
      console.error("Error generating captcha:", error);
      toast.error("Failed to generate captcha. Please try again.");
    }
  };

  // Toggle ABHA visibility
  const toggleAbhaVisibility = () => {
    setShowAbha(!showAbha);
    // Reformat the display
    if (!showAbha && abhano) {
      // Switching to visible - show formatted number
      const formatted = abhano.replace(
        /^(\d{2})(\d{0,4})(\d{0,4})(\d{0,4}).*/,
        (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-"),
      );
      setFormateAbha(formatted);
    } else if (abhano) {
      // Switching to masked - show all asterisks
      const maskedValue = abhano
        .split("")
        .map(() => "*")
        .join("");
      setFormateAbha(maskedValue);
    }
  };

  // Initialize captcha on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  /**
   * function used to format ABHA no. in input box with mask/unmask support with mask/unmask support
   */
  const handleAbhaChange = (e) => {
    const inputValue = e.target.value;

    if (showAbha) {
      // When visible, extract numeric values directly
      const numericValue = inputValue.replace(/\D/g, "");
      const limitedValue = numericValue.slice(0, 14);
      setAbhano(limitedValue);
      // Format as xx-xxxx-xxxx-xxxx
      const formatted = limitedValue.replace(
        /^(\d{2})(\d{0,4})(\d{0,4})(\d{0,4}).*/,
        (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-"),
      );
      setFormateAbha(formatted);

      // Validate ABHA number
      if (limitedValue.length === 0) {
        setAbhaError("ABHA number is required");
      } else if (limitedValue.length < 14) {
        setAbhaError("ABHA number must be 14 digits");
      } else {
        setAbhaError("");
      }
    } else {
      // When masked, compare lengths to determine if adding or removing
      const currentLength = formateAbha.length;
      const newLength = inputValue.length;

      if (newLength > currentLength) {
        // User is adding a digit - extract the new digit
        const newDigit = inputValue.replace(/\D/g, "").slice(-1);
        if (newDigit && abhano.length < 14) {
          const updatedValue = abhano + newDigit;
          setAbhano(updatedValue);
          const maskedValue = updatedValue
            .split("")
            .map(() => "*")
            .join("");
          setFormateAbha(maskedValue);
        } else {
          // No new digit, just restore the mask
          const maskedValue = abhano
            .split("")
            .map(() => "*")
            .join("");
          setFormateAbha(maskedValue);
        }
      } else if (newLength < currentLength) {
        // User is removing a digit (backspace)
        const updatedValue = abhano.slice(0, -1);
        setAbhano(updatedValue);
        const maskedValue = updatedValue
          .split("")
          .map(() => "*")
          .join("");
        setFormateAbha(maskedValue);
      }

      // Validate ABHA number for masked input
      const currentAbhaLength =
        abhano.length + (newLength > currentLength ? 1 : -1);
      if (currentAbhaLength === 0) {
        setAbhaError("ABHA number is required");
      } else if (currentAbhaLength < 14) {
        setAbhaError("ABHA number must be 14 digits");
      } else {
        setAbhaError("");
      }
    }
  };

  /**
   * Function used to set otp text
   */
  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only digits and up to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setOtpText(value);
      // Validate OTP
      if (value.length === 0) {
        setOtpError("OTP is required");
      } else if (value.length < 6) {
        setOtpError("OTP must be 6 digits");
      } else {
        setOtpError("");
      }
    }
  };

  // Send OTP Request
  const handleSendOtp = async () => {
    // Validate ABHA number (14 digits)
    if (abhano.length !== 14) {
      toast.error("Please enter a valid 14-digit ABHA number");
      return;
    }

    // Validate captcha with backend
    if (!captchaInput || captchaInput.trim() === "") {
      toast.error("Please enter the captcha.");
      return;
    }

    try {
      // Verify captcha with backend
      const captchaResponse = await axios.post(
        `${API_BASE_URL}/abha/captcha/validate`,
        {
          sessionId: captchaSessionId,
          captcha: captchaInput,
        },
      );

      if (!captchaResponse.data.success || !captchaResponse.data.valid) {
        toast.error("Invalid captcha. Please try again.");
        generateCaptcha(); // Regenerate captcha
        setCaptchaInput(""); // Clear input
        return;
      }
    } catch (error) {
      toast.error("Failed to validate captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    setIsPageLoading(true);
    try {
      // Format ABHA number as xx-xxxx-xxxx-xxxx
      const formattedAbhaNumber = abhano.replace(
        /^(\d{2})(\d{4})(\d{4})(\d{4})$/,
        "$1-$2-$3-$4",
      );
      // Encrypt ABHA number
      const encryptedAbha = await encryptString(formattedAbhaNumber);
      // Create session
      // const sessionResponse = await createSession();

      // if (sessionResponse?.accessToken && encryptedAbha) {
      if (encryptedAbha) {
        // setAccessToken(sessionResponse.accessToken);

        // Prepare request body
        const requestBody = {
          loginId: encryptedAbha,
        };

        const response = await axios.post(
          `${API_BASE_URL}/abha/account/re-activate/send-otp`,
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: sessionResponse.accessToken,
            },
          },
        );
        const dtresponse = response.data;
        if (dtresponse?.success) {
          setIsPageLoading(false);
          setTxnId(dtresponse.data.txnId);
          setShowOtpBox(true);
          setResendTimer(60);

          toast.success(dtresponse.data.message || "OTP sent successfully");
        } else {
          toast.error(dtresponse.data.message || "Failed to send OTP");
        }
      } else {
        toast.error("Failed to encrypt ABHA number");
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "X-token expired"
      ) {
        toast.error(error.response.data.message);
      } else if (
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else if (error.response.data?.error?.error?.message) {
        toast.error(error.response.data.error.error.message);
      } else {
        toast.error(
          error.response.data.message ||
            "Server error occurred. Please try again later.",
        );
      }
    } finally {
      setIsPageLoading(false);
    }
  };

  // Verify OTP
  const handleVerifyOtp = async () => {
    if (OtpText.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    setIsPageLoading(true);

    try {
      const encryptedOtp = await encryptString(OtpText);

      if (encryptedOtp) {
        const requestBody = {
          txnId: txnId,
          otp: encryptedOtp,
        };

        const response = await axios.post(
          `${API_BASE_URL}/abha/account/re-activate/verify-otp`,
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: accessToken,
            },
          },
        );
        const dtresponse = response.data;
        if (dtresponse.success) {
          if (dtresponse.data.authResult === "success") {
            setIsReactivated(true);
            setShowModal(true);
            // Reset form
            setShowOtpBox(false);
            setOtpText("");
            setFormateAbha("");
          } else {
            toast.error(
              dtresponse?.data?.message || "Wrong OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        } else {
          setIsPageLoading(false);
          toast.error("Failed to verify OTP");
        }
      } else {
        setIsPageLoading(false);
        toast.error("Failed to encrypt otp");
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "X-token expired"
      ) {
        toast.error(error.response.data.message);
      } else if (
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response.data.message ||
            "Server error occurred. Please try again later.",
        );
      }
    } finally {
      setIsPageLoading(false);
    }
  };

  // Handle resend OTP
  const handleResendOtp = async () => {
    if (resendCount >= 3) {
      toast.error("Maximum resend attempts reached.");
      return;
    }
    if (resendTimer > 0) {
      toast.error("Please wait before resending OTP.");
      return;
    }

    setIsPageLoading(true);
    try {
      // Format ABHA number as xx-xxxx-xxxx-xxxx
      const formattedAbhaNumber = abhano.replace(
        /^(\d{2})(\d{4})(\d{4})(\d{4})$/,
        "$1-$2-$3-$4",
      );
      const encryptedAbha = await encryptString(formattedAbhaNumber);
      if (encryptedAbha) {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const requestBody = {
            loginId: encryptedAbha,
          };

          const response = await axios.post(
            `${API_BASE_URL}/abha/account/re-activate/send-otp`,
            requestBody,
            {
              headers: {
                "Content-Type": "application/json",
                // accesstoken: sessionResponse.accessToken,
              },
            },
          );
          const dtresponse = response.data;
          if (dtresponse?.success) {
            setTxnId(dtresponse.data.txnId);
            setResendTimer(60);
            setResendCount(resendCount + 1);
            toast.success(
              dtresponse.data.message || "OTP resent successfully.",
            );
            setIsPageLoading(false);
          } else {
            toast.error(
              dtresponse?.data.message ||
                "Failed to resend OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } else {
        toast.error("Failed to encrypt ABHA number. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Failed to resend OTP. Please try again.",
      );
    }
  };

  // Timer effect
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [resendTimer]);

  // Auto-redirect after 5 seconds when reactivation is successful
  useEffect(() => {
    if (isReactivated && showModal) {
      const redirectTimer = setTimeout(() => {
        navigate("/login-ABHA");
      }, 5000);
      return () => clearTimeout(redirectTimer);
    }
  }, [isReactivated, showModal, navigate]);

  return (
    <>
      <ToastContainer />
      {isPageLoading && <Loader />}
      <div className="mainFlow reactivatePageDesign">
        <div className="container">
          <div className="pranHealtnMainUserFlow">
            <div className="abha-paranLogo">
              <img src={MixLogo} alt="Logo" />
            </div>
            <div className="userFlowAdharVer anotherPaddingPage">
              <div className="flowTitle">
                <h4>Reactivate ABHA</h4>
              </div>

              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}
              {successMessage && (
                <div className="success-message">{successMessage}</div>
              )}

              <div className="flow-feilds">
                {!showOtpBox ? (
                  <>
                    <div className="feilds">
                      <label>ABHA Number</label>
                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          className="filds-form"
                          placeholder="xx-xxxx-xxxx-xxxx"
                          value={formateAbha}
                          onChange={handleAbhaChange}
                          onCopy={(e) => e.preventDefault()}
                          onCut={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                        />
                        <span
                          className="material-icons"
                          onClick={toggleAbhaVisibility}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "#666",
                          }}
                        >
                          {showAbha ? "visibility" : "visibility_off"}
                        </span>
                      </div>
                      {abhaError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {abhaError}
                        </span>
                      )}
                      <span className="notes text-start">
                        14 digit ABHA Number
                      </span>
                    </div>

                    <div className="feilds">
                      <label>Captcha</label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f0f0f0",
                            padding: "5px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            flex: 1,
                            textAlign: "center",
                            userSelect: "none",
                            minHeight: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {captchaImage ? (
                            <img
                              src={captchaImage}
                              alt="Captcha"
                              style={{ maxWidth: "100%", height: "auto" }}
                            />
                          ) : (
                            <span style={{ color: "#999" }}>
                              Loading captcha...
                            </span>
                          )}
                        </div>
                        <i
                          className="material-icons"
                          onClick={generateCaptcha}
                          style={{
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "#007bff",
                          }}
                          title="Refresh Captcha"
                        >
                          refresh
                        </i>
                      </div>
                      <input
                        type="text"
                        className="filds-form"
                        placeholder="Enter captcha text"
                        value={captchaInput}
                        onChange={(e) => {
                          setCaptchaInput(e.target.value);
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                      />
                    </div>
                  </>
                ) : (
                  <div className="feilds">
                    <label>Enter OTP</label>
                    <input
                      type="text"
                      className="filds-form"
                      placeholder="Enter 6-digit OTP"
                      maxLength={6}
                      value={OtpText}
                      onChange={handleOtpChange}
                    />
                    {otpError && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "12px",
                          marginTop: "5px",
                          display: "block",
                        }}
                      >
                        {otpError}
                      </span>
                    )}
                    <span
                      className="notes text-end"
                      style={{
                        pointerEvents:
                          resendTimer > 0 || resendCount >= 3 ? "none" : "auto",
                        color:
                          resendTimer > 0 || resendCount >= 3
                            ? "#999"
                            : "#007bff",
                        cursor:
                          resendTimer > 0 || resendCount >= 3
                            ? "not-allowed"
                            : "pointer",
                      }}
                      onClick={handleResendOtp}
                    >
                      {resendTimer > 0
                        ? `00:${resendTimer < 10 ? "0" + resendTimer : resendTimer} Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`
                        : resendCount >= 3
                          ? "Maximum resend attempts reached"
                          : `Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`}
                    </span>
                  </div>
                )}

                <div className="feilds feildsBtn mt-5">
                  <button className="custBtn btnCancel" onClick={back}>
                    Back
                  </button>
                  <button
                    className={`custBtn ${(!showOtpBox && abhano.length === 14 && captchaInput.length > 0) || (showOtpBox && OtpText.length === 6) ? "btnSuccess" : "disabled"}`}
                    onClick={!showOtpBox ? handleSendOtp : handleVerifyOtp}
                    disabled={
                      (!showOtpBox &&
                        (abhano.length !== 14 || captchaInput.length === 0)) ||
                      (showOtpBox && OtpText.length !== 6)
                    }
                  >
                    {!showOtpBox ? "Get OTP" : "Verify OTP"}{" "}
                    <i className="material-icons">arrow_right_alt</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && <ReactivateModel onClose={() => setShowModal(false)} />}
    </>
  );
};

export default ReactivateABHA;
